import { Box, styled, Typography } from '@mui/material';

export const AccountContainerStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  height: '99px',
  [theme.breakpoints.down('sm')]: {
    gap: '14px',
  },
  [theme.breakpoints.up('sm')]: {
    height: '77px',
  },
  [theme.breakpoints.up('lg')]: {
    height: 'auto',
    translate: '0 calc(-25% + 4px)',
    padding: 0,
  },
}));

export const SelectorsStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '16px',
  [theme.breakpoints.up('sm')]: {
    gap: '12px',
  },
  [theme.breakpoints.up(820)]: {
    gap: '16px',
  },
  [theme.breakpoints.up('lg')]: {
    gap: '24px',
  },
  [theme.breakpoints.up('xxl')]: {
    gap: '60px',
  },
  [theme.breakpoints.up('xxxl')]: {
    gap: '40px',
  },
}));

export const SectionStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '3px',
  color: theme.palette.colors.selectedAndDetailBackground,
  fontSize: '12px',
  fontWeight: 900,

  [theme.breakpoints.up(820)]: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: '7px',
  },
  [theme.breakpoints.up('lg')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '3px',
  },
  [theme.breakpoints.up('xxxl')]: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: '7px',
  },
}));

export const BalanceContainerStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  color: theme.palette.colors.variantOnInfoBackground,
  fontSize: '12px',
  fontWeight: 900,
  height: '32px',
  minWidth: '140px',
}));

export const SpanStyled = styled(Typography)(({ theme, disabled }) => ({
  fontSize: '12px',
  color: disabled
    ? theme.palette.colors.disabledOnPrimaryBackground
    : theme.palette.colors.variantOnPrimaryBackground,
  textTransform: 'uppercase',
  fontWeight: 500,
  lineHeight: 'normal',
  letterSpacing: 'normal',
  whiteSpace: 'nowrap',
  [theme.breakpoints.down('lg')]: {
    fontSize: '10px',
  },
}));

export const NumberStyled = styled(Typography)(({ theme }) => ({
  fontFamily: 'Roboto Mono',
  fontSize: '12px',
  paddingLeft: '8px',
  paddingRight: '8px',
  backgroundColor: theme.palette.colors.infoBackground,
  height: '32px',
  display: 'flex',
  alignItems: 'center',
  fontWeight: 'bold',
  borderRadius: '4px',
  minWidth: '140px',
  [theme.breakpoints.down('lg')]: {
    backgroundColor: theme.palette.colors.primaryBackground,
  },
}));

export const CurrencyStyled = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  paddingLeft: '8px',
  height: '32px',
  display: 'flex',
  alignItems: 'center',
  backgroundColor: theme.palette.colors.infoBackground,
  paddingRight: '8px',
  borderRadius: '0 4px 4px 0',
}));

export const TradingBalanceStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.colors.onPrimaryBackground,
  fontSize: '12px',
  lineHeight: 'normal',
  letterSpacing: 'normal',
}));

export const LabelStyled = styled('span')(() => ({
  fontSize: '10px',
  fontWeight: 500,
  textTransform: 'uppercase',
  marginRight: '8px',
}));

export const BoldText = styled('span')(() => ({
  fontWeight: 'bold',
}));

export const DropdownContainer = styled(Box)(() => ({
  minWidth: '140px',
}));
